import { Type, ViewContainerRef } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

/**
 * Abre um diálogo de configuração de gadget/filtro no padrão nz do
 * projeto (classe global modal-size-80 dimensiona o corpo).
 *
 * O nzViewContainerRef é OBRIGATÓRIO aqui: o DashboardViewService é
 * provido no MainDashboardComponent (uma instância por dashboard) e o
 * modal só resolve essa instância através do injector da view do
 * dashboard — sem isso o creator perderia o contexto empresa/contrato.
 */
export function openGadgetModal(
    modal: NzModalService,
    viewContainerRef: ViewContainerRef,
    component: Type<unknown>,
    data: object
): NzModalRef {
    return modal.create({
        nzContent: component as Type<any>,
        nzData: data,
        nzFooter: null,          // botões vêm do actions-buttons interno (side-panel)
        nzClosable: false,
        nzMaskClosable: false,
        nzKeyboard: false,
        nzWidth: '80vw',
        nzClassName: 'modal-size-80',
        nzViewContainerRef: viewContainerRef,
    });
}
